import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';

import { HttpModule, Http } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { RestProvider } from '../providers/rest/rest';
import { DatePipe } from '@angular/common';
import { HomePageModule } from '../pages/home/home.module'
import { TabsPageModule } from '../pages/tabs/tabs.module';
import { LoginPage } from '../pages/login/login';
import { CalanderPageModule } from '../pages/calander/calander.module';
import { PipesModule } from '../pipes/pipes.module';
import { ReportsPageModule } from '../pages/reports/reports.module';
import { AdminPageModule } from '../pages/admin/admin.module';
import { AdminNextPageModule } from '../pages/admin-next/admin-next.module';
import { EventsPageModule } from '../pages/events/events.module';
import { EventNextPageModule } from '../pages/event-next/event-next.module';
import { ProfilePageModule } from '../pages/profile/profile.module';
import { PagesExpenditurePageModule } from '../pages/pages-expenditure/pages-expenditure.module';
import { PopoverPage } from '../pages/popover/popover';
import { PopoverPageModule } from '../pages/popover/popover.module';

@NgModule({
  declarations: [
    MyApp,
    //HomePage,
    //TabsPage,
    LoginPage,
    //CalanderPage,
    //ReportsPage,
    //AdminPage,
    //AdminNextPage,
    //EventsPage,
    //EventNextPage,
    //ProfilePage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    PipesModule,
    HomePageModule,
    TabsPageModule,
    CalanderPageModule,
    ReportsPageModule,
    AdminPageModule,
    AdminNextPageModule,
    EventsPageModule,
    EventNextPageModule,
    ProfilePageModule,
    PagesExpenditurePageModule,
    PopoverPageModule,
    IonicModule.forRoot(MyApp,{
      tabsPlacement: 'top',
      tabsLayout:'icon-end',
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    //HomePage,
    //TabsPage,
    LoginPage,
    //CalanderPage,
    //ReportsPage,
    //AdminPage,
    //AdminNextPage,
    //EventsPage,
    //EventNextPage,
    //ProfilePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    Http,
    RestProvider,
    DatePipe,
   
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts